// import { BaseTable as AliTable } from 'ali-react-table';
import BaseTable from './BaseTable';

export { TableStore } from './store';
export {
    connect,
    useStore,
    useResize,
    useIndex,
    useCheckbox,
    useSort,
    useExpandRow,
    useTreeTable,
    useFilter,
    usePagination,
    useErrorTips,
    useRowClick,
    useLocation,
    useContextMenu,
    useCellSelect,
    useHotKey,
    useDOM,
    useSimpleTable,
    useCardTable,
    useEditTable,
    useCache,
    // useCopy,
    useStyle,
    useAutoMerge,
    useGroupSort,
    useFieldSetting,
    useOprCol,
} from './libs';

import './index.less';

BaseTable.DemoTable = BaseTable;
BaseTable.BaseTable = BaseTable;

export default BaseTable;

export { getRowHeight } from './adapter/utils/handleProps';